<template>
  <!-- 选择车牌按钮 -->
  <el-form-item class="item block choose" label="车牌号">
    <el-button size="small" type="primary" @click="showDialog">选择车辆</el-button>
    <div class="orderlist" style="margin-top: 15px;">
      <div class="item" v-for="(c, i) in checkedLists" :key="'item' + i">
        <div class="row0">{{ c.driver }}-{{ c.license }}</div>
        <div class="row0">{{ c.tel || c.phone }}</div>
        <!-- 自有车辆字段 -->
        <div v-if="c.money">
          <div class="row1" v-for="(p, i) in modalListProps" :key="'item' + i">
            <div class="col0">{{ p.label }}：</div>
            <div class="col1">{{ c[p.key] }}</div>
          </div>
        </div>
        <!-- 雇佣车辆字段 -->
        <div v-if="c.company" class="row1">
          <!-- <div class="col0">所属公司：</div> -->
          <div class="col1">{{ c.company }}</div>
        </div>
      </div>
    </div>

    <Dialog class="dialog" ref="dialog" :title="title" @closed="onClose">
      <template #default>
        <slot name="start"></slot>
        <el-scrollbar class="content">
          <div v-if="modalList2 && modalList2.length" class="tit tit1">空闲车辆</div>
          <el-checkbox-group class="list" v-model="checkedIds" @change="onCheckChange">
            <el-checkbox class="item" v-for="(c, i) in modalList" :key="'itemm' + i" :label="c.id">
              <div class="row0">{{ c.license }}</div>
              <div class="row1">{{ c.driver }}</div>
            </el-checkbox>
          </el-checkbox-group>

          <div v-if="modalList2 && modalList2.length" class="tit tit2">在途车辆</div>
          <el-checkbox-group v-if="modalList2 && modalList2.length" class="list" v-model="checkedIds"
            @change="onCheckChange">
            <el-checkbox class="item" v-for="(c, i) in modalList2" :key="'itemm' + i" :label="c.id">
              <div class="row0">{{ c.license }}</div>
              <div class="row1">{{ c.driver }}</div>
            </el-checkbox>
          </el-checkbox-group>
        </el-scrollbar>

        <div class="btns">
          <el-button type="primary" @click="onModalSubmit">确 认</el-button>
          <el-button @click="onModalCancel">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </el-form-item>
</template>

<script>
export default {
  name: "VehicleSelect",
  props: {
    modalList: Array,
    modalList2: Array,
  },
  data() {
    return {
      checkedLists: [],
      modalListProps: [
        { label: '预支款', key: 'money' },
        { label: '押运员', key: 'escort' },
      ],
      title: '车辆列表',
      checkedIds: [],
    };
  },
  methods: {
    showDialog() {
      this.$refs.dialog && this.$refs.dialog.show()
    },
    hideDialog() {
      this.$refs.dialog && this.$refs.dialog.hide()
    },
    onClose() {
      // this.checkedIds = []
      // console.log(this.checkedIds)
    },
    onCheckChange(v) {
      console.log('check', v)
      // console.log(this.checkedIds)
    },
    onModalSubmit() {
      this.checkedLists = []
      const modalList = [...this.modalList]
      if (this.modalList2 && this.modalList2.length) {
        modalList.push(...this.modalList2)
      }
      // console.log('modalList', modalList)
      // console.log('checkedIds', this.checkedIds)
      modalList.map(c => {
        if (this.checkedIds.includes(c.id)) {
          if (c.money && !c.money.includes('元')) {
            c.money = c.money + '元'
          }
          this.checkedLists.push(c)
        }
      })
      // console.log('checkedLists', this.checkedLists)
      let noDriver = false
      this.checkedLists.map(v => {
        if (!v.driver) {
          noDriver = true
        }
      })
      if (noDriver) {
        this.$confirm('您选择的车辆未绑定司机是否继续派单', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.$emit("onChecked", this.checkedIds);
          this.hideDialog()
        }).catch(() => {
          // console.log('checkedIds', this.checkedIds)
          this.checkedIds = []
          // console.log('checkedIds', this.checkedIds)
          this.checkedLists = []
        });
      } else {
        this.$emit("onChecked", this.checkedIds);
        this.hideDialog()
      }
    },
    onModalCancel() {
      this.$emit("onChecked", []);
      this.hideDialog()
    },
  },
};
</script>

<style lang="less" scoped>
.choose {
  width: 100%;
  padding-right: 0;
  margin-right: 0;
  display: flex;

  .el-form-item__content {
    flex: 1;
  }

}

.orderlist {
  display: flex;
  flex-wrap: wrap;
  line-height: 20px;

  .item {
    width: 140px;
    margin: 0 15px 15px 0;
    position: relative;
    box-shadow: 0px 0px 8px rgb(0 0 0 / 10%);
    color: #000;
    font-size: 14px;
    padding: 13px 10px;
    border-radius: 2px;

    &:nth-child(8n) {
      margin-right: 0;
    }

    &.is-checked {
      box-shadow: 0px 0px 8px #409EFF;
    }

    /deep/ .el-checkbox__input {
      display: none;
    }

    /deep/ .el-checkbox__label {
      padding: 0;
    }

    .row0 {
      display: flex;
      margin: 5px 0;
    }

    .row1 {
      display: flex;
      margin-bottom: 5px;
    }

    .rowlast {
      display: flex;
      border-bottom: 1px solid #eee;
    }
  }
}

.dialog {
  /deep/ .el-dialog {
    width: 931px;

  }

  .content {
    height: 500px;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .tit {
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #303133;
    padding-left: 16px;
    position: relative;
    margin: 0 auto 16px;

    &::before {
      position: absolute;
      left: 0;
      top: 5px;
      content: '';
      width: 10px;
      height: 10px;
      background: #67C23A;
      border-radius: 50%;
    }

    &.tit2 {
      &::before {
        background: #F56C6C;
      }
    }
  }

  .list {
    display: flex;
    flex-wrap: wrap;

    .item {
      background: #FAFAFA;
      border-radius: 6px;
      border: 1px solid #FAFAFA;
      position: relative;
      margin: 0 15px 15px 0;
      position: relative;
      width: 136px;
      box-sizing: border-box;

      &:nth-child(6n) {
        margin-right: 0;
      }

      &.is-checked {
        border-color: #409EFF;
      }

      /deep/ .el-checkbox__input {
        position: absolute;
        right: 15px;
        top: 15px;
      }

      /deep/ .el-checkbox__label {
        padding: 0;
        display: block;
      }

      .row0 {
        padding: 15px;
        height: 14px;
        font-size: 14px;
        color: #303133;
        border-bottom: 1px solid #EBEEF5;
      }

      .row1 {
        padding: 10px 15px;
        height: 14px;
        font-size: 14px;
        color: #909399;
      }
    }
  }

  .btns {
    text-align: center;
    margin-left: 0;
  }
}
</style>
